export const stepOneData = [
  {
    heading: "Understanding Your Personal Loan Eligibility Results",
    // paras before heading
    paraOne:
      "The results you’ve received are a snapshot of your borrowing capacity based on the details you provided. Here's what the key metrics indicate:",

    resultList: [
      {
        head: "Eligible Loan Amount: ",
        info: "The maximum amount you can borrow based on your income, expenses, and other financial commitments.",
      },
      {
        head: " Estimated EMI: ",
        info: "The monthly repayment amount that suits your financial profile without causing undue stress on your budget. ",
      },
      {
        head: "Approval Probability: ",
        info: "This reflects how likely you are to get approved for a personal loan based on your credit score, income stability, and obligations.",
      },
    ],
    paraTwo:
      "These figures give you a strong foundation to assess your loan options and make informed financial decisions.",
  },
];

export const stepTwoData = [
  {
    heading: "Factors That Affect Personal Loan Eligibility",
    subtitle:
      "To better understand how your eligibility is calculated, let’s break down the key influencing factors:",
    factorsList: [
      {
        head: "Income and Financial Stability",
        info: "Your monthly income plays a crucial role in determining your eligibility. Lenders evaluate your disposable income after deducting fixed obligations like rent and existing EMIs.",
      },
      {
        head: "Credit Score",
        info: "A credit score of 750 or above increases your chances of approval and helps secure lower interest rates. If your score is below this threshold, lenders may still offer a loan, but at a higher rate.",
      },
      {
        head: "FOIR (Fixed Obligation to Income Ratio)",
        info: "FOIR is the ratio of your fixed monthly obligations to your total income. Most lenders prefer this to be below 40%-50%. Lower FOIR means higher eligibility.",
      },
      {
        head: "Employment Type and Stability",
        info: "Salaried employees with a steady job history or self-employed professionals with consistent income streams are viewed more favorably by lenders.",
      },
      {
        head: "Age ",
        info: "Your age affects the tenure of the loan. Younger applicants are eligible for longer tenures, while older applicants may have a shorter repayment period.",
      },
    ],
  },
];

export const stepThreeData = [
  {
    heading: "Why Use a Personal Loan Eligibility Calculator?",
    subtitle:
      "Using Minemi’s calculator before applying for a loan can save you time and effort. Here’s why:",

    eligibilityList: [
      {
        head: "Instant Insights: ",
        info: "Get immediate estimates of your borrowing capacity",
      },
      {
        head: "Better Financial Planning: ",
        info: "Understand your EMI burden and align it with your monthly budget.",
      },
      {
        head: "Avoid Rejection: ",
        info: "Pre-checking your eligibility reduces the chances of rejection and its impact on your credit score.",
      },
      {
        head: "Compare Loan Options: ",
        info: "Use the results to compare offers from various lenders and choose the best deal.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "How to Use Your Eligibility Results",
    subtitle:
      "Once you’ve calculated your eligibility, follow these steps to maximize its potential:",
    eligibilityList: [
      {
        head: "Set a Budget: ",
        info: "Use the eligible loan amount to define the range of expenses your loan can cover.",
      },
      {
        head: "Compare Lenders: ",
        info: "Check interest rates, processing fees, and loan terms from different banks and NBFCs.",
      },
      {
        head: "Optimize Your Profile: ",
        info: "Improve your credit score or reduce existing debts if you need a higher loan amount.",
      },
      {
        head: "Plan for EMIs: ",
        info: "Ensure the EMI fits comfortably within your monthly budget to avoid financial stress.",
      },
    ],
  },
];
export const stepFiveData = [
  {
    heading: "Tips to Improve Your Personal Loan Eligibility",
    subtitle:
      "If your results are not as favorable as you hoped, here are some practical ways to improve your eligibility:",

    improveEligibilityList: [
      {
        head: "Enhance Your Credit Score: ",
        info: "Pay your credit card bills and EMIs on time, reduce outstanding debts, and avoid multiple loan inquiries.",
      },
      {
        head: "Reduce Fixed Obligations: ",
        info: "Clear smaller debts or consolidate loans to free up disposable income.",
      },
      {
        head: "Opt for a Co-Applicant: ",
        info: "Adding a family member with a stable income can significantly boost eligibility.",
      },
      {
        head: "Increase Your Income: ",
        info: "If possible, negotiate a salary hike or show additional income sources like rent or investments.",
      },
      {
        head: "Choose a Longer Tenure: ",
        info: "While this reduces EMI amounts, ensure the overall interest cost remains manageable.",
      },
    ],
  },
];
export const stepSixData = [
  {
    heading: "Why Choose Minemi for Your Personal Loan Needs?",
    subtitle:
      "At Minemi, we’re committed to making personal loans accessible and hassle-free. Our platform not only helps you calculate your eligibility but also offers:",

    needsList: [
      {
        head: "Personalized Recommendations: ",
        info: "Get tailored loan offers from top lenders.",
      },
      {
        head: "Transparency: ",
        info: "No hidden charges or fine print—just clear, actionable insights.",
      },
      {
        head: "Smart Tools: ",
        info: "Use our suite of calculators to plan every aspect of your loan journey.",
      },
    ],
  },
];
